import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import { colorCodesForAvatar } from "../../../../../constants/index";
import { chracterPosition } from "../../../../../utils/index";

function RoleBadge({ role }) {
  const isAdmin = role === "Admin"; 
  const isSuperAdmin = role === "Super Admin";
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        height: 24,
        width: isSuperAdmin ? 96 : 56,
        borderRadius: "100px",
        border: "1px solid",
        borderColor: isAdmin | isSuperAdmin ? "#148DFD" : "#D5DCE1",
        background: isAdmin | isSuperAdmin ? "#F3FBFF" : "#FAFAFA",
        color: "#405261",
        fontFamily: "Inter",
        fontSize: 12,
        fontWeight: 500,
        flexShrink: 0,
        paddingLeft:'9px',
        paddingBottom:'1px'
      }}
    >
      {role}
    </Box>
  );
}

export default function TeamDetailMembersSection({ members }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        sx={{
          color: "#061522",
          fontFamily: "Inter",
          fontSize: 20,
          fontWeight: 500,
          lineHeight: "34px",
          mb: 1.5,
        }}
      >
        Team Members ({members.length})
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {members.map((member) => {
          const letter = (member.name || "").substring(0, 1).toUpperCase();
          return (
            <Box
              key={member.id}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                p: 2,
                borderRadius: "8px",
                border: "1px solid #E5E9EC",
                background: "#FFF",
              }}
            >
              {member.avatar ? (
                <Avatar src={member.avatar} alt={member.name} sx={{ width: 40, height: 40 }} />
              ) : (
                <Avatar
                  sx={{
                    width: 40,
                    height: 40,
                    fontSize: 14,
                    bgcolor: colorCodesForAvatar[chracterPosition(letter)] || "#405261",
                  }}
                >
                  {letter}
                </Avatar>
              )}
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography
                  sx={{
                    color: "#061522",
                    fontFamily: "Inter",
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "18px",
                  }}
                >
                  {member.name}
                </Typography>
                <Typography
                  sx={{
                    color: "#405261",
                    fontFamily: "Inter",
                    fontSize: 12,
                    fontWeight: 400,
                    lineHeight: "18px",
                  }}
                >
                  {member.email}
                </Typography>
              </Box>
              <RoleBadge role={member.role} />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
